import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';
import { useVendor } from '../../../context/VendorContext';

const { FiX, FiDollarSign, FiArrowRight, FiCheckCircle, FiHome } = FiIcons;

const WithdrawalModal = ({ isOpen, onClose }) => {
  const { vendorData, requestWithdrawal } = useVendor();
  const [amount, setAmount] = useState('');
  const [step, setStep] = useState(1);

  const handleWithdraw = () => {
    if (requestWithdrawal(Number(amount))) {
      setStep(2);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-accent-navy/60 backdrop-blur-md">
      <motion.div 
        initial={{ scale: 0.95, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        className="bg-white rounded-[40px] shadow-2xl w-full max-w-md overflow-hidden border border-brand-dark"
      >
        <div className="p-8 border-b border-brand-light flex justify-between items-center">
          <h3 className="text-2xl font-serif text-accent-navy">Withdraw Funds</h3>
          <button onClick={onClose} className="p-2 hover:bg-brand-light rounded-full text-text-muted"><SafeIcon icon={FiX} /></button>
        </div>

        <div className="p-8">
          {step === 1 ? (
            <div className="space-y-8">
              <div className="bg-brand-light p-6 rounded-3xl text-center">
                <p className="text-[10px] font-black uppercase tracking-widest text-text-muted mb-1">Available Balance</p>
                <p className="text-4xl font-serif text-accent-navy">${vendorData.balance.toLocaleString()}</p>
              </div>

              <div className="space-y-4">
                <label className="text-[10px] font-black uppercase tracking-widest text-accent-navy">Payout Amount</label>
                <div className="relative">
                  <SafeIcon icon={FiDollarSign} className="absolute left-5 top-1/2 -translate-y-1/2 text-accent-gold" />
                  <input 
                    type="number" 
                    className="w-full pl-12 pr-6 py-4 bg-brand-light border-2 border-brand-dark rounded-2xl focus:border-accent-gold outline-none text-lg font-bold"
                    placeholder="0.00"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                  />
                </div>
              </div>

              <div className="flex items-center gap-4 p-4 bg-blue-50 border border-blue-100 rounded-2xl">
                <SafeIcon icon={FiHome} className="text-blue-500" />
                <div>
                  <p className="text-[10px] font-black uppercase text-blue-500">Destination Account</p>
                  <p className="text-xs font-bold text-accent-navy">Chase Bank • {vendorData.bankAccount}</p>
                </div>
              </div>

              <button 
                onClick={handleWithdraw}
                disabled={!amount || Number(amount) > vendorData.balance}
                className="w-full btn-primary py-5 text-[10px] font-black uppercase tracking-widest flex items-center justify-center gap-3 shadow-xl"
              >
                Initiate Transfer <SafeIcon icon={FiArrowRight} />
              </button>
            </div>
          ) : (
            <div className="text-center py-8">
              <div className="w-20 h-20 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <SafeIcon icon={FiCheckCircle} className="w-10 h-10" />
              </div>
              <h4 className="text-2xl font-serif text-accent-navy mb-2">Request Submitted</h4>
              <p className="text-sm text-text-muted font-light leading-relaxed mb-8">
                Your funds are being processed and will arrive in your bank account within 2-3 business days.
              </p>
              <button onClick={onClose} className="btn-secondary px-10">Done</button>
            </div>
          )}
        </div>
      </motion.div>
    </div>
  );
};

export default WithdrawalModal;